import * as Api from '@ViewModels';
import * as React from 'react';
import { BlogPostRequest } from '../../../models/Blogs';

export interface IBlogPostContext {
	blogPost?: Api.IBlogPost;
	request?: BlogPostRequest;
	sendFromUser?: Partial<Api.IUser>;
	setBlogPost(blogPost: Api.IBlogPost): void;
	setRequest: (request: BlogPostRequest) => void;
	setSendFromUser: (user: Partial<Api.IUser>) => void;
}

export const BlogPostContext = React.createContext<IBlogPostContext>(null);

export const BlogPostContextProvider = ({ children }: { children: React.ReactNode }) => {
	const context = useCreatePostContext();

	return <BlogPostContext.Provider value={context}>{children}</BlogPostContext.Provider>;
};

export const useCreatePostContext = () => {
	const [context, setContext] = React.useState<IBlogPostContext>({
		blogPost: null,
		setBlogPost: (blogPost: Api.IBlogPost) => {
			setContext(prev => ({ ...prev, blogPost }));
		},
		request: null,
		setRequest: (request: BlogPostRequest) => {
			setContext(prev => ({ ...prev, request }));
		},
		sendFromUser: null,
		setSendFromUser: (user: Partial<Api.IUser>) => {
			setContext(prev => ({ ...prev, sendFromUser: user }));
		},
	});

	return context;
};
